<template>
  <section class="anchor application" :id="$t('header.nav[5].link')">
    <div class="container">
      <h2 class="application__title" v-html="$t('home.application.title')"></h2>
      <div class="row">
        <div class="col-x-lg-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <div class="application__image">
            <img src="~@/assets/img/home/application/product.png" alt="" />
          </div>
        </div>
        <div class="col-x-lg-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <div class="application__description">
            <h5
              class="application__description-title"
              v-html="$t('home.application.description.title')"
            ></h5>
            <h6
              class="application__description-subtitle"
              v-html="$t('home.application.description.subtitle')"
            ></h6>
            <div
              class="application__description-text"
              v-html="$t('home.application.description.text')"
            ></div>
            <a
              @click="mainBuy()"
              :href="$t('home.application.description.button.link')"
              target="_blank"
              class="application__description-btn"
            >
              {{ $t("home.application.description.button.title") }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Application",
  methods: {
    mainBuy() {
      // eslint-disable-next-line no-undef
      gtag("event", "click", { event_category: "main_buy" });
    }
  }
};
</script>
